import { computed, inject, Injectable, signal } from '@angular/core';

import { v4 as randomUUID } from 'uuid';

import { PhNotificationPanelComponent } from '@ph-shared/components/notification/notification-panel/notification-panel.component';
import { PhNotificationItem } from '@ph-shared/components/notification/notification/notification.interface';

import {
  PhOverlay,
  PhOverlayHorizontalPosition,
  PhOverlayPositionBuilder,
  PhOverlayVerticalPosition,
} from '../overlay';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  private o = inject(PhOverlay);
  private pb = inject(PhOverlayPositionBuilder);

  private _notifications = signal<PhNotificationItem[]>([]);
  readonly notifications = this._notifications.asReadonly();
  readonly count = computed(() => this._notifications().length);

  constructor() {
    this.o.attach(PhNotificationPanelComponent, {
      position: this.pb.position({
        horizontal: PhOverlayHorizontalPosition.end,
        vertical: PhOverlayVerticalPosition.top,
      }),
      data: { notificationService: this },
    });
  }

  push(value: PhNotificationItem): void {
    this._notifications.update((notifications) => [{ ...value, id: randomUUID() }, ...notifications]);
  }

  remove(id: string): void {
    this._notifications.update((notifications) => notifications.filter((notification) => notification.id !== id));
  }

  clear(): void {
    this._notifications.set([]);
  }
}
